module.exports = __webpack_public_path__ + "media/logos/forbes-logo-white-testimonial-a020e7d5.png";